import IPostMessage from '../IPostMessage';
import Triggers from './Triggers/Triggers';

export default class Timing {
	public static MESSAGE_PREFIX: string = 'timing';

	public readonly triggers: Triggers;

	/** @internal */
	constructor(
		private messagePrefix: string,
		private postMessage: IPostMessage<any>,
	) {
		this.triggers = new Triggers(this.getMessagePrefix(), this.postMessage);
	}

	private getMessagePrefix() {
		return this.messagePrefix + '.' + Timing.MESSAGE_PREFIX;
	}
}
